import { __read } from 'tslib';
import React, { useState } from 'react';
import CloseIcon from '../CloseIcon/index.js';

var MobileMenu = function MobileMenu(props) {
  var icon = props.icon,
    menus = props.menus;
  var _a = __read(useState(false), 2),
    isActive = _a[0],
    setIsActive = _a[1];
  var renderMenu = function renderMenu() {
    return /*#__PURE__*/React.createElement("div", {
      className: "mobile-menu-popover-box"
    }, menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
      var _a, _b, _c, _d, _e, _f;
      var title = item.title,
        link = item.link,
        _g = item.target,
        target = _g === void 0 ? '_self' : _g;
      return /*#__PURE__*/React.createElement("a", {
        key: title + index,
        className: "mobile-menu-popover-item",
        href: link,
        target: target,
        rel: "noopener noreferrer",
        "data-track-name": (_b = (_a = item.trackInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '文字链',
        "data-track-value": (_d = (_c = item.trackInfo) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : title,
        "data-track-category": (_f = (_e = item.trackInfo) === null || _e === void 0 ? void 0 : _e.category) !== null && _f !== void 0 ? _f : '头部导航'
      }, title);
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mobile-menu-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mobile-menu-icon-wrapper",
    onClick: function onClick() {
      return setIsActive(!isActive);
    }
  }, !isActive ? icon : /*#__PURE__*/React.createElement(CloseIcon, null)), isActive && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mobile-menu-popover hover-cls"
  }, renderMenu()), /*#__PURE__*/React.createElement("div", {
    className: "mobile-menu-popover-mask",
    onClick: function onClick() {
      setIsActive(false);
    },
    onTouchMove: function onTouchMove() {
      setIsActive(false);
    }
  }))));
};

export { MobileMenu as default };
